import useOrderList from "./useOrderList";
import {DataGrid} from "../../../../common";
import OrderView from "./OrderView";


export default function OrderList() {
  const {grid} = useOrderList();

  return (
    <DataGrid
      {...grid}
      renderModalForm={props => <OrderView {...props} />}
      modalProps={{
        maxWidth: "md",
      }}
      headerItems={["search", "refresh"]}
      canDelete={false}
      canView={true}
    />
  );
}